'use client';
import { useIsLG, useIsMD, useIsXL } from '@repo/ui/src/utils/useMediaQuery';
import { ImageProps } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { appConfig } from '@repo/ui/src/utils/appConfig';

export interface FeatureCardProps {
  toutContent: ToutContentProps;
  backgroundImage: ImageProps;
  index?: number;
  totalSlides?: number;
}

const FeatureCarouselCard = ({
  toutContent,
  backgroundImage,
  index = 0,
  totalSlides = 1,
}: FeatureCardProps) => {
  const lgAndUp = useIsXL();
  const mdAndUp = useIsLG();
  const smAndUp = useIsMD();
  const isMeater = appConfig.isMeater;

  const backgroundImageUrl = lgAndUp
    ? buildImageSrc(backgroundImage, 1500, 9, 5)
    : mdAndUp
      ? buildImageSrc(backgroundImage, 1280, 7, 5)
      : smAndUp
        ? buildImageSrc(backgroundImage, 960, 1, 1)
        : buildImageSrc(backgroundImage, 600, 1, 1);

  const altText = backgroundImage?.altTag ?? toutContent?.heading ?? `slide ${index + 1}`;

  return (
    <div
      className="focus:outline-brand-400 relative"
      tabIndex={-1}
      role="group"
      aria-label={`slide ${index + 1} of ${totalSlides}`}
    >
      <div className="relative w-full h-[646px] flex items-end px-[40px] py-[25px] overflow-hidden">
        <img
          src={backgroundImageUrl}
          alt={altText}
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        {/* Gradient overlay */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: isMeater
              ? 'linear-gradient(to right, rgba(0, 0, 0, 0.71), rgba(0, 0, 0, 0.25), rgba(255, 255, 255, 0))'
              : 'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
          }}
        />
        <div className="relative z-10 flex flex-col gap-[15px] max-w-[500px]">
          <h3 className="tra-text-web-heading-3 uppercase text-white">{toutContent?.heading}</h3>
          {toutContent?.description && (
            <p className="tra-text-web-body-l text-white">{toutContent.description}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureCarouselCard;
